import Reveal from "@/components/Reveal";
import { DASHBOARD_URL } from "@/lib/links";

export default function Closing() {
  return (
    <section className="cta" data-testid="closing-section">
      <div className="wrap">
        <Reveal>
          <h2>Bring intelligence into every customer conversation</h2>
          <p>See how ThinkWire fits your sales workflow, offer knowledge and team structure.</p>
          <a
            className="btn btn-blue"
            href={DASHBOARD_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="closing-cta-button"
          >
            Get started <span className="arrow">→</span>
          </a>
        </Reveal>
      </div>
    </section>
  );
}
